import type React from 'react';

import { Spinner } from '@change/ds-core-ui/Spinner';

import { LazyComponent } from '#src/app/shared/components/layout/lazy';

import type { SignFormProps } from './SignForm';
import type { SignFormRefreshWrapper } from './SignFormRefreshWrapper';

async function loadSignForm(): Promise<typeof SignFormRefreshWrapper> {
	return (await import(/* webpackChunkName: "pages/petitionDetails-signForm" */ './SignFormRefreshWrapper'))
		.SignFormRefreshWrapper;
}

export const SignFormLoader: React.FC<SignFormProps> = (props) => {
	return (
		<LazyComponent loadComponent={loadSignForm} fallback={<Spinner className="mx-auto mt-16 size-6" />} {...props} />
	);
};

export const preloadSignForm = loadSignForm;
